import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const settingsCategoryReducer = combineReducers({
  searchResult: searchResultReducer,
});

export default settingsCategoryReducer;
